/* global Swiper */
$(() => {
  $('.js-alerts-slider').each(function sliderInit() {
    const $this = $(this);
    const swiper = new Swiper($this, {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      autoplay: {
        delay: 3000,
      },
    });
  });

  $('.js-alert-close').click(function handler() {
    const $this = $(this);
    const $parent = $this.closest('.js-alerts');

    $parent.slideUp();
  });
});



// WEBPACK FOOTER //
// ./src/scripts/components/sliders/alerts-slider.js